import { renderRichText } from "@storyblok/react";
import { Headline } from "@/components/typography/Headline";
import type { TextContentStoryblok } from "@/component-types-sb";

import { RichText } from "@/components/typography/RichText";

type TextContentProps = {
  blok: TextContentStoryblok;
};

const TextContent = ({ blok }: TextContentProps) => (
  <div className="px-4 md:px-8 py-8 md:py-12 text-black-100 max-w-4xl mx-auto">
    <Headline as="h4" size="medium" className="mb-8">
      {blok.headline}
    </Headline>
    <RichText html={renderRichText(blok.text)} className="text-copy mb-4" />
  </div>
);

export default TextContent;
